import React from 'react';
import PropTypes from 'prop-types';

const GoBizValuePropComp = ({close}) => {
  return (
    <div>
      <div className="popOverlay popShow" onClick={close}></div>
      <div className="popModal zoom large popShow db" id="goBizBenifit">
        <div className="popContent">
          <a
            href="javascript:void(0)"
            className="fr icon-close font12Lt popClose"
            onClick={close}
          ></a>
          <h4 className="popHdr">Business Profile</h4>
          <div className="popBody">
            <h2 className="width100 fl ico28 greyDr">You are switching to goBiz</h2>
            <p className="width100 fl ico15 grey lh1-2 padT5">
              Now avail special benifits on Flight or Hotel bookings
            </p>
            <div className="width100 fl padTB20 marginT20">
              <div className="width100 fl">
                <div className="col-md-6 col-sm-6 col-xs-12">
                  <div className="col-md-2 col-sm-2 col-xs-2 pad0">
                    <div className="homeIconHldr pad10">
                      <i className="icon-flights ico20 white"></i>
                    </div>
                  </div>
                  <div className="col-md-10 col-sm-10 col-xs-10">
                    <div className="ico16 padB5 greyDr fmed lh1-2">Special benefits on Flight</div>
                    <div className="ico14 lh1-2 greyLt">
                      Get Free meals, Free seat selection, Free Cancellation and Free reschedule on
                      selected airlines
                    </div>
                  </div>
                </div>
                <div className="col-md-6 col-sm-6 col-xs-12">
                  <div className="col-md-2 col-sm-2 col-xs-2 pad0">
                    <div className="homeIconHldr pad5">
                      <i className="icon-hotels white ico20 pad5 fl"></i>
                    </div>
                  </div>
                  <div className="col-md-10 col-sm-10 col-xs-10">
                    <div className="ico16 padB5 fmed greyDr lh1-2">Special benefits on Hotel</div>
                    <div className="ico14 lh1-2 greyLt">
                      Avail exclusive deals on select hotels and earn double cashback on your
                      booking
                    </div>
                  </div>
                </div>
              </div>
              <div className="width100 fl padT20">
                <div className="col-md-6 col-sm-6 col-xs-12">
                  <div className="col-md-2 col-sm-2 col-xs-2 pad0">
                    <div className="homeIconHldr pad5">
                      <i className="icon-goCash white ico30"></i>
                    </div>
                  </div>
                  <div className="col-md-10 col-sm-10 col-xs-10">
                    <div className="ico16 padB5 fmed greyDr lh1-2">
                      Earn cashback for your personal travel
                    </div>
                    <div className="ico14 lh1-2 greyLt">
                      Get goCash cashback on your business travel that can be used for personal
                      travel booking
                    </div>
                  </div>
                </div>
                <div className="col-md-6 col-sm-6 col-xs-12">
                  <div className="col-md-2 col-sm-2 col-xs-2 pad0">
                    <div className="homeIconHldr pad10">
                      <i className="icon-refund ico20 white"></i>
                    </div>
                  </div>
                  <div className="col-md-10 col-sm-10 col-xs-10">
                    <div className="ico16 padB5 fmed greyDr lh1-2">Easier Reimbursement</div>
                    <div className="ico14 lh1-2 greyLt">
                      Get GST compliance voucher for easier reimbursement on your business travel.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

GoBizValuePropComp.propTypes = {
  close: PropTypes.function,
};

export const GoBizValueProp = GoBizValuePropComp;
